import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  // Start at 14 minutes 13 seconds
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 13);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="bg-red-600 text-white py-2 px-4 text-center font-bold text-sm md:text-base flex items-center justify-center gap-2 animate-pulse" data-id="element-1">
      <Clock className="w-4 h-4" data-id="element-2" />
      <span data-id="element-3">
        ⏳ OFERTA EXPIRA EN: {String(minutes).padStart(2, '0')}:
        {String(seconds).padStart(2, '0')} | 🔥 SOLO QUEDAN 3 CUPOS
      </span>
    </div>;
}